import { Component, OnInit, ViewChild } from '@angular/core';
import { ParameterService } from 'src/app/services/panelM/update-params/parameter.service';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  standalone: false,
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss']
})
export class ServiceComponent implements OnInit {

  params: any;
  displayedColumns: string[] = ['Description', 'Value', 'button'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(private paramsService: ParameterService, private readonly router: Router, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.paramsService.parameterService().subscribe((data: any) => {
      this.params = new MatTableDataSource<any>(data.ParameterList);
      this.params.paginator = this.paginator;
    }, error => {
      console.error(error);
      this.router.navigateByUrl('/portalM');
    });
  }

  updateRow(element) {
    this.paramsService.updateParams(element).subscribe((data: any) => {
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 1000,
      });
    }, (data) => {
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 1000,
      });
    });
  }
}
